import { isDevEnvironment } from "./misc";
import { USE_TEST_PRICES } from "./variables";

const IS_DEV = isDevEnvironment();

export const DYNAMIC_GIFT_PRICE_IDS = IS_DEV ? {
  124.99: "price_1RGra6LvyjRKGUTXTE6YBUln",
  99.99: "price_1RGrV0LvyjRKGUTXwMoUpDPn",
} : {
  124.99: "price_1QICWyLvyjRKGUTXOJUpQxDs",
  99.99: "price_1QSm6ALvyjRKGUTX8WufWny5",
  // TEST ONLY
  1.0: "price_1QKMjHLvyjRKGUTXSYhZ3iFh",
};

export const PAID_TRIAL_PRICE_IDS = {
  1: IS_DEV ? "price_1O5uDoLvyjRKGUTXHZIqck8o" : "price_1R7I5QLvyjRKGUTXNXp6YsjL",
  7: IS_DEV ? "price_1R6xpULvyjRKGUTXe4lEAyRk" : "price_1R7I5QLvyjRKGUTXV4WalvUh",
  11.41: IS_DEV ? "price_1R6xpULvyjRKGUTXVX80fEkk" : "price_1R7I5QLvyjRKGUTXjo4iJEHY",
};

export const UNIVERSAL_PRICE_IDS = {
  99.99: IS_DEV ? "price_1R6xvoLvyjRKGUTX09q5TrlP" : "price_1R7fzZLvyjRKGUTX9XoHOqlc",
  124.99: IS_DEV ? "price_1R6y2OLvyjRKGUTXVQyceDEz" : "price_1Pqn4BLvyjRKGUTXFzFNdPM4",
};

// Might want to change the way we handle localized prices in the future
export const PADDLE_PRICE_IDS = {
  trial: {
    99.99: IS_DEV || USE_TEST_PRICES ? "pri_01jsfb5y09z1b6h4jwry1fjxy2" : "pri_01jt0r6bzzrn4zq3fz6d0bm0hj",
    124.99: IS_DEV || USE_TEST_PRICES ? "pri_01jsyqfjccaby06nd7jmh3hxxs" : "pri_01jt0qzda4w1af81rpy50wct8r",
  },
  no_trial: {
    // Monthly price
    23.99: IS_DEV || USE_TEST_PRICES ? "pri_01jz5dwc0zzk4mn0anf7meyxnq" : "pri_01jz5enkxam182fe3mwcy122ev",
    // Quarterly price
    42.99: IS_DEV || USE_TEST_PRICES ? "pri_01jz5e8k9w5nr0hk8gatvzptw3" : "pri_01jz5ftjwqp003s11f2g8p9d0p",
    // Annual price
    99.99: IS_DEV || USE_TEST_PRICES ? "pri_01jsydsv6mg8e3m2bg7exmpe7g" : "pri_01jt0rdxkdkea4sbvytx522n27",
    // Annual price 2
    124.99: IS_DEV || USE_TEST_PRICES ? "pri_01jsydjxyr3twzjv0nymta3943" : "pri_01jt0qgjhr611q1mdpr3a5bpk1",
  },
};

export const PLANS_CHECKOUT_PRICE_IDS = {
  23.99: IS_DEV ? "price_1ReEzVLvyjRKGUTXIFd8kdgU" : "price_1RdyncLvyjRKGUTXWfCAGmMb",
  42.99: IS_DEV ? "price_1ReEzVLvyjRKGUTXjjRX1LDp" : "price_1ReK88LvyjRKGUTXupMHThwt",
  99.99: IS_DEV ? "price_1ReEzVLvyjRKGUTX1h4DbKYq" : "price_1RdyjyLvyjRKGUTXZJRxQmpH",
};
